import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiServices from "../ApiServices/request-handler";
import { SwalAlert } from "../components";
import Analytics from "../firebase_services/analytics";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../context/authContext";

const fetchNotifications = async ({ queryKey }) => {
  const [, userId] = queryKey;
  const response = await apiServices.notifications(userId);
  return response?.data;
};
export const useNotifications = (userId) => {
  return useQuery({
    queryKey: ["notifications", userId],
    queryFn: fetchNotifications,
    enabled: !!userId,
  });
};

export const useJobsDashboardSaveMutation = (setLoadingapi, currentPage) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (savedData) => {
      const response = await apiServices.saveJobs(savedData);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingapi(false);
      SwalAlert(data?.status, data?.message, "success");
      queryClient.invalidateQueries(["jobslisting", currentPage]);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapi(false);
    },
  });
};

export const useMutationJobDelete = (setLoadingapi, currentPage) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (deletesavedJobData) => {
      const response = await apiServices.deleteSavedJobs(deletesavedJobData);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingapi(false);
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
      queryClient.invalidateQueries(["jobslisting", currentPage]);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapi(false);
    },
  });
};

const fetchChatHeads = async ({ queryKey }) => {
  const [, userID] = queryKey;
  const response = await apiServices.chatMessage(userID);
  return response?.data?.chats;
};

export const useChatHead = (userId) => {
  return useQuery({
    queryKey: ["chathead", userId],
    queryFn: fetchChatHeads,
    enabled: !!userId,
  });
};

export const UseDeleteChatMutation = (
  chatheadsId,
  queryClient,
  setchatheadsId,
  setchatheadsName
) => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async () => {
      const response = await apiServices.deleteChat(chatheadsId);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["chathead"]);
      setchatheadsId(null);
      setchatheadsName(null);
      dispatch({
        type: "UPDATE_USER_CHAT_DATA",
        payload: { userChatData: "" },
      });
    },
  });
};

export const useDeleteMessageMutation = (
  queryClient,
  chatheadsId,
  setSelectedMessage
) => {
  return useMutation({
    mutationFn: async (messageId) => {
      const response = await apiServices.deleteChatMessage(messageId);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getMessages", chatheadsId]);
      setSelectedMessage(null);
    },
  });
};

const fetchMessages = async ({ queryKey }) => {
  const [, ChatId] = queryKey;
  const response = await apiServices.getMessages(ChatId);
  return response?.data?.messages ?? [];
};

export const useGetMessages = (chatheadsId) => {
  return useQuery({
    queryKey: ["getMessages", chatheadsId],
    queryFn: fetchMessages,
    enabled: !!chatheadsId,
  });
};

export const useSendMessageMutation = (
  userId,
  chatheadsId,
  queryClient,
  setNewMessage
) => {
  return useMutation({
    mutationFn: async (message) => {
      const response = await apiServices.sendMessage(
        chatheadsId,
        userId,
        message
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getMessages", chatheadsId]);
      setNewMessage("");
    },
  });
};

const fetchDashboardCounts = async ({ queryKey }) => {
  const [, roleId, userRole, employerId] = queryKey;
  const response = await apiServices.dashboardCounts(
    roleId,
    userRole,
    employerId
  );
  return response?.data;
};

export const useDashboardCounts = (roleId, userRole, employerId) => {
  return useQuery({
    queryKey: ["dashboardCounts", roleId, userRole, employerId],
    queryFn: fetchDashboardCounts,
    enabled: !!roleId,
  });
};

const fetchEmployer = async ({ queryKey }) => {
  const [, employerId] = queryKey;
  const response = await apiServices.employers(employerId);
  return response?.data?.data;
};
export const useEmployer = (employerId) => {
  return useQuery({
    queryKey: ["employer", employerId],
    queryFn: fetchEmployer,
    enabled: !!employerId,
  });
};

const fetchFavourite = async ({ queryKey }) => {
  const [, userId, instance_types] = queryKey;
  const response = await apiServices.favouritedAndLikeEventAndNews(
    userId,
    instance_types
  );
  return response?.data?.data;
};

export const useFavouriteLike = (userId, instance_types) => {
  return useQuery({
    queryKey: ["favourite", userId, instance_types],
    queryFn: fetchFavourite,
    keepPreviousData: true,
  });
};
